import { useSyncExternalStore } from "react";

/**
 * Whether the /sport socket is connected. The live lists are pushed over it, so
 * their polls stop while it is up and resume as the fallback when it drops.
 */
let connected = false;
const listeners = new Set<() => void>();

export const setSportSocketConnected = (next: boolean) => {
  if (connected === next) return;
  connected = next;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const useSportSocketConnected = (): boolean =>
  useSyncExternalStore(
    subscribe,
    () => connected,
    () => false,
  );
